import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../Layout";
import TelephonyLeftNav from "../../Layout/TelephonyLeftNav";
import CallLogs from "../../containers/CallLogs";

export default function CallLogsPage() {
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    // Show loading when navigating to this page
    setIsNavigating(true);
    const timer = setTimeout(() => setIsNavigating(false), 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <Layout leftNav={<TelephonyLeftNav />}>
      <CallLogs isNavigating={isNavigating} />
    </Layout>
  );
} 